import { media } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩解读</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">漫画解读、盘点推荐、深度科普，换个角度看漫画</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {media.map((item) => (
            <a
              key={item.id}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded">{item.duration}</span>
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500/90 text-background-50 text-xs rounded">{item.category}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}